import { useEffect, useMemo, useRef } from 'react';


interface Props {
    isViewMode: boolean;
    isFinalized: boolean;
    isFinalSaving: boolean;
    isDirty: boolean;
    autoSaveCallback: () => void;
}

export function useAutoSave({
    isViewMode,
    isFinalized,
    isFinalSaving,
    isDirty,
    autoSaveCallback,
}: Props) {
    const AUTO_SAVE_INTERVAL = 30_000;
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const latestCallbackRef = useRef(autoSaveCallback);


    useEffect(() => {
        latestCallbackRef.current = autoSaveCallback;
    }, [autoSaveCallback]);


    const scheduleAutoSave = useMemo(() => {
        return () => {
            timerRef.current = setInterval(() => {
                latestCallbackRef.current();
            }, AUTO_SAVE_INTERVAL);
            console.log('Auto save scheduled');
        };
    }, []);

    const clearAutoSave = useMemo(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
                console.log('Auto save unscheduled');
            }
        };
    }, []);

    useEffect(() => {
        if (isViewMode || isFinalized || isFinalSaving || !isDirty) {
            clearAutoSave();
            return undefined;
        }

        scheduleAutoSave();
        return () => {
            clearAutoSave();
        };
    }, [isViewMode, isFinalized, isFinalSaving, isDirty, clearAutoSave, scheduleAutoSave]);
}
